export enum Enums {
  ACCS_GRP = 'accs_grp',
  PAGE = 'page',
  LIC_TYPE = 'lic_type',
  WKFL_EVNT = 'wkfl_evnt'
}
